import { render, staticRenderFns } from "./AgentAffiliatesTable.vue?vue&type=template&id=fbe94e6c"
import script from "./AgentAffiliatesTable.vue?vue&type=script&lang=js"
export * from "./AgentAffiliatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports